import React, {useEffect, useState} from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {Row} from '../../../../../components/layout';

interface UnfilledRadioButtonProps {
  globalStyles: any;
  width?: any;
  height?: any;
}

function UnfilledRadioButton({
  globalStyles,
  width,
  height,
}: UnfilledRadioButtonProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>63BD4ADD-FB0A-490B-A78B-9CEE1E364597@1,5x</title>
      <g
        id="08---Consultas-Online"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="MY-M-08-01-09-Pagamento-cartao-de-credito"
          transform="translate(-44.000000, -900.000000)"
          fill="#FFFFFF"
          stroke={globalStyles.primaryColor}
          strokeWidth="2">
          <g id="multibanco" transform="translate(44.000000, 898.000000)">
            <g id="Checkbox" transform="translate(0.000000, 2.000000)">
              <circle id="Oval" cx="12" cy="12" r="11"></circle>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(UnfilledRadioButton));
